


import React, { useState } from "react";

const gallery = [
  //  { image: "images/fleets/1.jpeg", },
   { image: "images/fleets/2.jpeg", },
  //  { image: "images/fleets/3.jpeg", },
   { image: "images/fleets/4.jpeg", },
  //  { image: "images/fleets/5.jpeg", },
   { image: "images/fleets/8.jpeg", },

   { image: "images/fleets/6.jpeg", },
   { image: "images/fleets/7.jpeg", },
   { image: "images/fleets/9.jpeg", },
   { image: "images/fleets/10.jpeg", },
   { image: "images/fleets/11.jpeg", },
   { image: "images/fleets/12.jpeg", },
   { image: "images/fleets/13.jpeg", },
   { image: "images/fleets/14.jpeg", },
   { image: "images/fleets/15.jpeg", },
 
 
  {
    id: 5,
    name: "Hyundai Aura",
    seats: "4 Seater",
    image: "images/fleets/Aura.jpg",
  },

  {
    id: 7,
    name: "Maruti Dzire",
    seats: "4 Seater",
    image: "images/fleets/Dzire.jpg",
  },

  {
    id: 8,
    name: "Ertiga",
    seats: "7 Seater",
    image: "images/fleets/Ertiga.jpg",
  },

  {
    id: 1,
    name: "Kia Carens",
    seats: "7 Seater",
    image: "images/fleets/Kia.jpg",
  },
  // {
  //   id: 10,
  //   name: "Innova ",
  //   seats: "7 Seater",
  //   image: "images/fleets/Innova.jpg",
  // },

  {
    id: 10,
    name: "Innova Crysta",
    seats: "7 Seater",
    image: "images/fleets/Innova-Crysta.jpg",
  },

  {
    id: 6,
    name: "Mini Bus",
    seats: "30-50 Seater",
    image: "images/fleets/Bus.jpg",
  },
  {
    id: 3,
    name: "Tempo Traveller",
    seats: "12-17 Seater",
    image: "images/fleets/Tempo-traveler.jpg",
  },

  {
    id: 4,
    name: "Urbania",
    seats: "17 Seater",
    image: "images/fleets/urbania.jpg",
  },



  {
    id: 6,
    name: "Bus",
    seats: "30-50 Seater",
    image: "images/fleets/Bus.jpg",
  },
];
const Gallery = () => {
  const [currentIndex, setCurrentIndex] = useState(null);

  const openImage = (index) => {
    setCurrentIndex(index);
  };

  const closeImage = () => {
    setCurrentIndex(null);
  };

  const nextImage = () => {
    setCurrentIndex((prev) =>
      prev === gallery.length - 1 ? 0 : prev + 1
    );
  };

  const prevImage = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? gallery.length - 1 : prev - 1
    );
  };

  return (
    <>
      <div className="breadcrumb-bar text-center">
        <h2 className="text-white">Gallery</h2>
      </div>

      <div className="container py-5">
        <div className="row">
          {gallery.map((item, index) => (
            <div key={item.id} className="col-lg-4 col-md-6 mb-4">
              <div className="gallery-card borderr" onClick={() => openImage(index)}>
                <img src={item.image} alt={item.name} />
                <h5>{item.name}</h5>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* LIGHTBOX */}
      {currentIndex !== null && (
        <div className="lightbox">
          <span className="close darkcolorrrr" onClick={closeImage}>✖</span>

          <span className="prev" onClick={prevImage}>❮</span>
          <img
            src={gallery[currentIndex].image}
            alt="preview"
            className="lightbox-img "
          />
          <span className="next" onClick={nextImage}>❯</span>
        </div>
      )}
    </>
  );
};

export default Gallery;